// https://observablehq.com/@ridgenb/map-unit-factsheet@4907
import define1 from "./e93997d5089d7165@2284.js";

export default function define(runtime, observer) {
  const main = runtime.module();
  main.variable(observer("title")).define("title", ["md"], function(md){return(
md`# Map Unit Factsheet`
)});
  main.variable(observer("surveyInfoDesc")).define("surveyInfoDesc", ["dataSurveyInfo"], function(dataSurveyInfo)
{
  var div = document.createElement('div');

  if (dataSurveyInfo.length > 0) {
    let surveyInfoHeading = document.createElement('h2');
    surveyInfoHeading.innerHTML = `Soil Survey`;
    div.appendChild(surveyInfoHeading);

    let surveyInfoSubHeading = document.createElement('p');
    surveyInfoSubHeading.innerHTML = `This soil mapunit was mapped within the following soil survey:`;
    div.appendChild(surveyInfoSubHeading);
  }

  return div;
}
);
  main.variable(observer("surveyInfo")).define("surveyInfo", ["dataSurveyInfo"], function(dataSurveyInfo)
{
  var div = document.createElement('div');
  if (dataSurveyInfo.length > 0) {
    let surveyTitle = document.createElement('div');
    surveyTitle.innerHTML = `<strong>Survey Title:</strong> ${dataSurveyInfo[0].surveyTitle}`;
    div.appendChild(surveyTitle);

    let surveyScale = document.createElement('div');
    surveyScale.innerHTML = `<strong>Survey Scale:</strong> ${dataSurveyInfo[0].surveyScale}`;
    div.appendChild(surveyScale);

    let surveyDate = document.createElement('div');
    surveyDate.innerHTML = `<strong>Survey Date:</strong> ${dataSurveyInfo[0].surveyDate}`;
    div.appendChild(surveyDate);

    let origin = document.createElement('div');
    origin.innerHTML = `<strong>Origin:</strong> ${dataSurveyInfo[0].origin}`;
    div.appendChild(origin);

    let mapUnitDelineationMethod = document.createElement('div');
    mapUnitDelineationMethod.innerHTML = `<strong>Map Unit Delineation Method:</strong> ${dataSurveyInfo[0].mapUnitDelineationMethod}`;
    div.appendChild(mapUnitDelineationMethod);

    let mapunitLabellingMethod = document.createElement('div');
    mapunitLabellingMethod.innerHTML = `<strong>Map Unit Labelling Method:</strong> ${dataSurveyInfo[0].mapunitLabellingMethod}`;
    div.appendChild(mapunitLabellingMethod);

    let siblingBasePropertyClassificationMethod = document.createElement('div');
    siblingBasePropertyClassificationMethod.innerHTML = `<strong>Sibling Base Property Classification Method:</strong> ${dataSurveyInfo[0].siblingBasePropertyClassificationMethod}`;
    div.appendChild(siblingBasePropertyClassificationMethod);

    // let surveyMethodNotes = document.createElement('div');
    // surveyMethodNotes.innerHTML = `<strong>Survey Method Notes:</strong> ${dataSurveyInfo[0].surveyMethodNotes}`;
    // div.appendChild(surveyMethodNotes);

    let description = document.createElement('div');
    description.innerHTML = `<strong>Description:</strong> ${dataSurveyInfo[0].description}`;
    div.appendChild(description);
  }

  return div;
}
);
  main.variable(observer("surveyInfoMUDesc")).define("surveyInfoMUDesc", ["dataSurveyInfo"], function(dataSurveyInfo)
{
  var div = document.createElement('div');
  div.setAttribute("style", "padding-bottom: 2em;");
  if (dataSurveyInfo.length > 0 && dataSurveyInfo[0].muDescription != null) {
    let mapUnitDesc = document.createElement('div');
    mapUnitDesc.innerHTML = `<strong>Map Unit Description:</strong> ${dataSurveyInfo[0].muDescription}`;
    div.appendChild(mapUnitDesc);
  }

  return div;
}
);
  main.variable(observer("mapDesc")).define("mapDesc", ["dataPolygon","md"], function(dataPolygon,md)
{
  if (dataPolygon.length > 0) {
    return md`Areas with ${dataPolygon[0].soilMapUnitCode} map unit code are shown on the map below. A soil map unit is a collection of areas that have the same soils (i.e. siblings) in the same proportion.`;
  }
}
);
  main.variable(observer("map")).define("map", ["DOM","width","graphWidth","L","dataPolygon","Wkt","proj4"], function*(DOM,width,graphWidth,L,dataPolygon,Wkt,proj4)
{
  // You'll often see Leaflet examples initializing a map like L.map('map'),
  // which tells the library to look for a div with the id 'map' on the page.
  // In Observable, we instead create a div from scratch in this cell, so it's
  // completely self-contained.
  let container = DOM.element('div', {
    style: `width:${width};height:${graphWidth / 1.1}px;`
  });
  // let container = DOM.element('div', {
  //   style: `width:${width}px;height:${width / 1.6}px`
  // });

  // Note that I'm yielding the container pretty early here: this allows the
  // div to be placed on the page. This is important, because Leaflet uses
  // the div's .offsetWidth and .offsetHeight to size the map. If I were
  // to only return the container at the end of this method, Leaflet might
  // get the wrong idea about the map's size.
  yield container;

  // Now we create a map object and add a layer to it.
  let map = L.map(container).setView([-41.838875, 171.7799], 6);
  let osmLayer = L.tileLayer(
    'http://{s}.google.com/vt/lyrs=s,h&x={x}&y={y}&z={z}',
    {
      maxZoom: 20,
      opacity: 0.75,
      subdomains: ['mt0', 'mt1', 'mt2', 'mt3']
    }
  ).addTo(map);

  const polygons = [];
  for (let i = 0; i < dataPolygon.length; i++) {
    var wkt = new Wkt.Wkt();
    // Read in any kind of WKT string
    wkt.read(dataPolygon[i].shape);

    // Define the NZTM projection
    proj4.defs(
      "EPSG:2193",
      "+proj=tmerc +lat_0=0 +lon_0=173 +k=0.9996 +x_0=1600000 +y_0=10000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs +axis=neu"
    );

    // Convert NZTM projection into WGS84 and push into an array
    let coordinates = [];
    for (let i = 0; i < wkt.components[0].length; i++) {
      let testVar = proj4('EPSG:2193', 'WGS84', [
        wkt.components[0][i].y,
        wkt.components[0][i].x
      ]);
      coordinates.push([testVar[1], testVar[0]]);
    }

    // Take all of the coordinates and draw on the map
    var polygon = L.polygon(coordinates, { color: 'red' });
    polygons.push(polygon);
    // zoom the map to the polygon
  }

  const group = L.featureGroup(polygons);
  group.addTo(map);
  map.fitBounds(group.getBounds());

  // Disable the ability to scroll to zoom
  //map.scrollWheelZoom.disable();
}
);
  main.variable(observer("proj4")).define("proj4", ["require"], function(require){return(
require('proj4')
)});
  main.variable(observer("Wkt")).define("Wkt", ["require"], function(require){return(
require('wicket')
)});
  main.variable(observer("tableDesc")).define("tableDesc", ["html"], function(html){return(
html`<h2>Soil properties of the siblings within the soil map unit</h2><p>This table shows the details of the soil siblings within the map unit. The profile available water (Paw) is a measure of the capacity of the soil sibling to store water to a depth of 1 metre. Click the links below to find out more about each item:</p><p><a href="https://soils.landcareresearch.co.nz/describing-soils/nzsc/soil-order/" target="_blank">Soil Order</a>, <a href="https://smap.landcareresearch.co.nz/support/glossary/#drainage_class" target="_blank">Drainage Class</a>, <a href="https://smap.landcareresearch.co.nz/support/glossary/#depth_class" target="_blank">Depth Class</a></p>`
)});
  main.variable(observer("tableSibling")).define("tableSibling", ["d3","tableHead","dataTable"], function(d3,tableHead,dataTable)
{
  const table = d3.create("table");

  table.style({ width: "100%" });

  table
    .append("thead")
    .join("tr")
    .selectAll("th")
    .data(tableHead)
    .join("th")
    .text(d => d)
    .style("background-color", "#aaa")
    .style("color", "#fff");

  table
    .append("tbody")
    .selectAll("tr")
    .data(dataTable)
    .join("tr")
    .selectAll("td")
    .data(row => d3.entries(row))
    .join("td")
    .text(d => {
      if (d.value != "NULL") {
        return d.value;
      } else {
        return "-";
      }
    });

  return table.node();
}
);
  main.variable(observer("tableHead")).define("tableHead", function(){return(
[
  'No.',
  'Smap name',
  'Proportion (%)',
  'Depth',
  'Texture',
  'Drainage class',
  'PAW (mm)',
  'Order'
]
)});
  main.variable(observer("chartDesc2")).define("chartDesc2", ["md"], function(md){return(
md`## Texture graph
This graph shows the texture profile of the siblings found in the map unit. Each horizon is coloured according to its texture.`
)});
  main.variable(observer("chartTexture")).define("chartTexture", ["d3","width","height","dataTexture","crossHatch","colorTexture","x","y","appendImages","dataNames","xAxis","yAxis","chartMargins","margin","appendBarrierLine"], function(d3,width,height,dataTexture,crossHatch,colorTexture,x,y,appendImages,dataNames,xAxis,yAxis,chartMargins,margin,appendBarrierLine)
{
  const svg = d3
    .create("svg")
    .attr("viewBox", [0, 0, width, height])
    .style("overflow", "visible")
    .style("font", "12px sans-serif");

  const bar = svg
    .append("g")
    .selectAll("g")
    .data(dataTexture)
    .enter()
    .append("g");

  const bar_enter = bar
    .selectAll("rect")
    .data(d => d)
    .enter();

  bar_enter
    .append("rect")
    .attr("fill", (d, i) => {
      if (d.data.thickType == "R" && d.key == "rock") {
        svg.call(crossHatch);
        return crossHatch.url();
      } else {
        return colorTexture(d.data.texture[d.key]);
      }
    })
    .attr("x", (d, i) => x(d.data.smapName))
    .attr("y", d => y(d[0]))
    .attr("width", x.bandwidth())
    .attr("height", d => {
      if (isNaN(y(d[1]) - y(d[0]))) {
        return 0;
      } else {
        return y(d[1]) - y(d[0]);
      }
    })
    .attr("stroke", "black")
    .attr("stroke-width", 2);

  appendImages(bar_enter, dataNames.length);

  svg
    .append("g")
    .call(xAxis)
    .selectAll('text')
    .style('text-anchor', 'start')
    .style("font", "12px sans-serif")
    .attr('transform', 'translate(5, -3), rotate(-45)');
  // svg.append("g").call(xAxis);

  svg.append("g").call(yAxis);

  svg
    .append("text")
    .attr("transform", "rotate(-90)")
    .attr("y", chartMargins.left - 50)
    .attr("x", 0 - height / 2 - margin.top)
    .attr("dy", "1em")
    .text("Depth (cm)");

  appendBarrierLine(dataTexture, svg, "rootBarrier", "purple");

  return svg.node();
}
);
  main.variable(observer("chartTextureLegend1")).define("chartTextureLegend1", ["d3","DOM","appendLegendText","margin","appendLegend2"], function(d3,DOM,appendLegendText,margin,appendLegend2)
{
  const svg = d3
    .select(DOM.svg(125, 180))
    .style("overflow", "visible")
    .style("font", "12px sans-serif");

  appendLegendText(svg, "Texture", 0, margin.top);
  appendLegend2(svg);

  return svg.node();
}
);
  main.variable(observer("chartTextureLegend2")).define("chartTextureLegend2", ["d3","DOM","appendLegendText","margin","appendStoneContentLegend2"], function(d3,DOM,appendLegendText,margin,appendStoneContentLegend2)
{
  const svg = d3
    .select(DOM.svg(125, 250))
    .style("overflow", "visible")
    .style("font", "12px sans-serif");

  appendLegendText(svg, "Stone Content", 0, margin.top);
  appendStoneContentLegend2(svg, 10, 0);

  return svg.node();
}
);
  main.variable(observer("chartTextureLegend3")).define("chartTextureLegend3", ["d3","DOM","appendLegendText","margin","appendOtherLegend2"], function(d3,DOM,appendLegendText,margin,appendOtherLegend2)
{
  const svg = d3
    .select(DOM.svg(140, 130))
    .style("overflow", "visible")
    .style("font", "12px sans-serif");

  appendLegendText(svg, "Other", 0, margin.top);
  appendOtherLegend2(svg, 10);

  return svg.node();
}
);
  main.variable(observer("appendLegendText")).define("appendLegendText", function(){return(
function(object, text, xPos, yPos) {
  object
    .append("text")
    .attr("x", xPos)
    .attr("y", yPos)
    .text(text)
    .style("font-weight", "bold");
}
)});
  main.variable(observer("tiling")).define("tiling", function()
{
  return { 1: 8, 2: 4, 3: 3, 4: 2, 5: 2 };
}
);
  main.variable(observer("images")).define("images", function()
{
  return {
    light: "https://i.imgur.com/C82rRAo.png",
    medium: "https://i.imgur.com/fsEy73X.png",
    heavy: "https://i.imgur.com/eayuJRk.png",
    veryHeavy: "https://i.imgur.com/4YA2gbi.png"
  };
}
);
  main.variable(observer("appendImages")).define("appendImages", ["imageSelect","y","x"], function(imageSelect,y,x){return(
function(obj, siteLength) {
  var repetitions = 1;
  if (siteLength == 1) {
    repetitions = 8;
  } else if (siteLength == 2) {
    repetitions = 4;
  } else if (siteLength == 3) {
    repetitions = 3;
  } else if (siteLength >= 4 && siteLength <= 6) {
    repetitions = 2;
  }

  let maxStacks = 10;
  for (var xRep = 0; xRep < repetitions; xRep++) {
    for (var yRep = 1; yRep <= maxStacks; yRep++) {
      obj
        .append("svg:image")
        .attr("xlink:href", d => imageSelect(d.data.stoneContent[d.key]))
        .attr("preserveAspectRatio", "none")
        .attr('height', d => {
          if (isNaN(y(d[1]) - y(d[0]))) {
            return 0;
          } else {
            let heightReps = Math.round((d[1] - d[0]) / 10);
            if (yRep <= heightReps) {
              return (y(d[1]) - y(d[0])) / heightReps;
            } else {
              return 0;
            }
          }
        })
        .attr("width", (x.bandwidth() - 2) / repetitions)
        .style("opacity", 0.675)
        .attr('x', d => {
          return (
            x(d.data.smapName) + 1 + ((x.bandwidth() - 2) / repetitions) * xRep
          );
        })
        .attr('y', d => {
          if (isNaN(y(d[1]) - y(d[0]))) {
            return 0;
          } else {
            let heightReps = Math.round((d[1] - d[0]) / 10);
            if (yRep <= heightReps) {
              return y(d[0]) + ((y(d[1]) - y(d[0])) / heightReps) * (yRep - 1);
            } else {
              return 0;
            }
          }
        });
    }
  }
}
)});
  main.variable(observer("imageSelect")).define("imageSelect", ["images"], function(images){return(
function(stones) {
  if (stones == 1) {
    return images.light;
  } else if (stones == 2) {
    return images.medium;
  } else if (stones == 3) {
    return images.heavy;
  } else if (stones == 4) {
    return images.veryHeavy;
  } else {
    return "";
  }
}
)});
  main.variable(observer("chartDesc3")).define("chartDesc3", ["html"], function(html){return(
html`<h2>Permeability graph</h2><p>This graph shows the permeability profile of the siblings found in the map unit. Each horizon is coloured according to its permeability. Click <a href="https://smap.landcareresearch.co.nz/support/glossary/#permeability_profile" target="_blank">here</a> for more information on permeability.</p>`
)});
  main.variable(observer("viewof selectedColorP")).define("viewof selectedColorP", ["select"], function(select){return(
select({
  title: "Color",
  description: "Please pick a color",
  options: [
    { value: 0, label: 'Blue' },
    { value: 1, label: 'Purple' },
    { value: 2, label: 'Green' },
    { value: 3, label: 'Grey' },
    { value: 4, label: 'Red' },
    { value: 5, label: 'Rainbow' },
    { value: 6, label: 'Sinebow' },
    { value: 7, label: 'Warm' },
    { value: 8, label: 'Cool' },
  ],
})
)});
  main.variable(observer("selectedColorP")).define("selectedColorP", ["Generators", "viewof selectedColorP"], (G, _) => G.input(_));
  main.variable(observer("chartPerm")).define("chartPerm", ["d3","width","height","dataPerm","crossHatch","pColor","x","y","xAxis","yAxis","margin","appendBarrierLine"], function(d3,width,height,dataPerm,crossHatch,pColor,x,y,xAxis,yAxis,margin,appendBarrierLine)
{
  const svg = d3
    .create("svg")
    .attr("viewBox", [0, 0, width, height])
    .style("overflow", "visible")
    .style("font", "12px sans-serif");

  const bar = svg
    .append("g")
    .selectAll("g")
    .data(dataPerm)
    .enter()
    .append("g");

  const bar_enter = bar
    .selectAll("rect")
    .data(d => d)
    .enter();

  bar_enter
    .append("rect")
    .attr("fill", (d, i) => {
      if (d.key == "rock") {
        svg.call(crossHatch);
        return crossHatch.url();
      } else {
        return pColor(d.data.permeability[d.key]);
      }
    })
    .attr("x", (d, i) => x(dataPerm.names[i]))
    .attr("y", d => y(d[0]))
    .attr("width", x.bandwidth())
    .attr("height", d => {
      if (isNaN(y(d[1]) - y(d[0]))) {
        return 0;
      } else {
        return y(d[1]) - y(d[0]);
      }
    })
    .attr("stroke", "black")
    .attr("stroke-width", 2);

  bar_enter
    .append("text")
    .attr("x", (d, i) => x(dataPerm.names[i]) + x.bandwidth() / 2)
    .attr("y", d => {
      if (isNaN(y(d[1]) - y(d[0]))) {
        return 0;
      } else {
        return y(d[0]) + (y(d[1]) - y(d[0])) / 2 + 5;
      }
    })
    .text(d => {
      if (
        typeof d.data.permeability[d.key] !== 'undefined' &&
        !isNaN(y(d[1]) - y(d[0])) &&
        d.data.permeability[d.key] !== ""
      ) {
        return d.data.permeability[d.key].toUpperCase();
      }
    })
    .style("font-weight", "bold")
    .style("font-size", "1.2em")
    .style("text-anchor", "middle");

  svg
    .append("g")
    .call(xAxis)
    .selectAll('text')
    .style('text-anchor', 'start')
    .style("font", "12px sans-serif")
    .attr('transform', 'translate(5, -3), rotate(-45)');

  svg.append("g").call(yAxis);

  svg
    .append("text")
    .attr("transform", "rotate(-90)")
    .attr("y", margin.left - 50)
    .attr("x", 0 - height / 2 - margin.top)
    .attr("dy", "1em")
    .text("Depth (cm)");

  appendBarrierLine(dataPerm, svg, "impermeableFhNum", "#962E2B");

  return svg.node();
}
);
  main.variable(observer("chartPermeabilityLegend1")).define("chartPermeabilityLegend1", ["d3","DOM","appendLegendText","margin","appendLegendPermeability"], function(d3,DOM,appendLegendText,margin,appendLegendPermeability)
{
  const svg = d3
    .select(DOM.svg(230, 150))
    .style("overflow", "visible")
    .style("font", "12px sans-serif");

  appendLegendText(svg, "Permeability", 0, margin.top);
  appendLegendPermeability(svg);

  return svg.node();
}
);
  main.variable(observer("chartPermeabilityLegend2")).define("chartPermeabilityLegend2", ["d3","DOM","appendLegendText","margin","appendOtherLegend3"], function(d3,DOM,appendLegendText,margin,appendOtherLegend3)
{
  const svg = d3
    .select(DOM.svg(170, 130))
    .style("overflow", "visible")
    .style("font", "12px sans-serif");

  appendLegendText(svg, "Other", 0, margin.top);
  appendOtherLegend3(svg, 10);

  return svg.node();
}
);
  main.variable(observer("chartDescAW")).define("chartDescAW", ["html"], function(html){return(
html`<h2>Available Water Graph</h2><p>This graph shows the available water profile of the siblings found in the map unit. This is capacity of the soil to hold water that is available to plants. Each horizon is coloured according to its percent available water content. Click <a href="https://smap.landcareresearch.co.nz/support/glossary/#profile_available_water_paw" target="_blank">here</a> for more information on available water.</p>`
)});
  main.variable(observer("chartAW")).define("chartAW", ["d3","width","height","dataAW","crossHatch","colorAW","textures","x","y","xAxis","yAxis","margin","appendBarrierLine"], function(d3,width,height,dataAW,crossHatch,colorAW,textures,x,y,xAxis,yAxis,margin,appendBarrierLine)
{
  const svg = d3
    .create("svg")
    .attr("viewBox", [0, 0, width, height])
    .style("overflow", "visible")
    .style("font", "12px sans-serif");

  const bar = svg
    .append("g")
    .selectAll("g")
    .data(dataAW)
    .enter()
    .append("g");

  const bar_enter = bar
    .selectAll("rect")
    .data(d => d)
    .enter();

  bar_enter
    .append("rect")
    .attr("fill", (d, i) => {
      if (d.key == "rock") {
        svg.call(crossHatch);
        return crossHatch.url();
      } else {
        let availableWater = d.data.availableWater[d.key];
        let colorKey = -1;
        if (availableWater < 10) {
          colorKey = 0;
        } else if (availableWater >= 10 && availableWater < 15) {
          colorKey = 1;
        } else if (availableWater >= 15 && availableWater < 20) {
          colorKey = 2;
        } else if (availableWater >= 20 && availableWater < 30) {
          colorKey = 3;
        } else if (availableWater >= 30) {
          colorKey = 4;
        }

        let color = colorAW(colorKey);

        if (d.data["rootBarrier"] != 0 && d.data["rootBarrier"] <= d.key + 1) {
          let barrierHatch = textures
            .lines()
            .orientation("2/8", "6/8")
            .stroke("#555")
            .size(9)
            .strokeWidth(2)
            .background(color);
          svg.call(barrierHatch);
          return barrierHatch.url();
        } else {
          return color;
        }
      }
    })
    .attr("x", (d, i) => x(dataAW.names[i]))
    .attr("y", d => y(d[0]))
    .attr("width", x.bandwidth())
    .attr("height", d => {
      if (isNaN(y(d[1]) - y(d[0]))) {
        return 0;
      } else {
        return y(d[1]) - y(d[0]);
      }
    })
    .attr("stroke", "black")
    .attr("stroke-width", 2)
    .style("opacity", 0.7);

  bar_enter
    .append("text")
    .attr("x", (d, i) => x(dataAW.names[i]) + x.bandwidth() / 2)
    .attr("y", d => {
      if (isNaN(y(d[1]) - y(d[0]))) {
        return 0;
      } else {
        return y(d[0]) + (y(d[1]) - y(d[0])) / 2 + 5;
      }
    })
    .text(d => {
      if (
        typeof d.data.availableWater[d.key] !== 'undefined' &&
        !isNaN(y(d[1]) - y(d[0])) &&
        d.data.availableWater[d.key] !== ""
      ) {
        return "" + Math.round(d.data.availableWaterMm[d.key]) + "mm";
      }
    })
    .style("font-weight", "bold")
    .style("font-size", "1.2em")
    .style("text-anchor", "middle");

  svg
    .append("g")
    .call(xAxis)
    .selectAll('text')
    .style('text-anchor', 'start')
    .style("font", "12px sans-serif")
    .attr('transform', 'translate(5, -3), rotate(-45)');
  svg.append("g").call(yAxis);

  svg
    .append("text")
    .attr("transform", "rotate(-90)")
    .attr("y", margin.left - 50)
    .attr("x", 0 - height / 2 - margin.top)
    .attr("dy", "1em")
    .text("Depth (cm)");

  appendBarrierLine(dataAW, svg, "rootBarrier", "purple");

  return svg.node();
}
);
  main.variable(observer("chartAWLegend1")).define("chartAWLegend1", ["d3","DOM","appendLegendText","margin","appendLegendAW"], function(d3,DOM,appendLegendText,margin,appendLegendAW)
{
  const svg = d3
    .select(DOM.svg(130, 150))
    .style("overflow", "visible")
    .style("font", "12px sans-serif");

  appendLegendText(svg, "Available Water", 0, margin.top);
  appendLegendAW(svg);

  return svg.node();
}
);
  main.variable(observer("chartAWLegend2")).define("chartAWLegend2", ["d3","DOM","appendLegendText","margin","appendLegendAW2"], function(d3,DOM,appendLegendText,margin,appendLegendAW2)
{
  const svg = d3
    .select(DOM.svg(150, 170))
    .style("overflow", "visible")
    .style("font", "12px sans-serif")
    .style("opacity", 0.7);

  appendLegendText(svg, "Other", 0, margin.top);
  appendLegendAW2(svg, 10, "purple");

  return svg.node();
}
);
  main.variable(observer("chartDesc4")).define("chartDesc4", ["md"], function(md){return(
md`## Proportion of siblings in this map unit
Graph is coloured according to the NZSC soil order of each sibling within this map unit.`
)});
  main.variable(observer("chartBar")).define("chartBar", ["d3","width","proportionBarHeight","dataMapUnitBar","xProportionBar","dataBar","yProportionBar","crossHatch","colorPie","graphWidth","marginStackedBar","xAxisProportionBar"], function(d3,width,proportionBarHeight,dataMapUnitBar,xProportionBar,dataBar,yProportionBar,crossHatch,colorPie,graphWidth,marginStackedBar,xAxisProportionBar)
{
  const svg = d3
    .create("svg")
    .attr("viewBox", [0, 0, width, proportionBarHeight])
    .style("font", "12px sans-serif");

  svg
    .append("g")
    .selectAll("rect")
    .data(dataMapUnitBar)
    .join("rect")
    .attr("x", (d, i) => {
      if (i == 0) {
        return xProportionBar(0);
      } else {
        return xProportionBar(dataBar[i - 1]);
      }
    })
    .attr("y", d => yProportionBar(0))
    .attr("width", d => {
      return xProportionBar(d.smapHubSiblingProportion) - xProportionBar(0);
    })
    .attr("height", yProportionBar.bandwidth())
    .attr("fill", d => {
      if (d.fullSmapName == "Bare rock") {
        svg.call(crossHatch);
        return crossHatch.url();
      } else {
        return colorPie(d.nzscOrderTxt);
      }
    })
    .attr("stroke", "black")
    .attr("stroke-width", 2);

  svg
    .append("g")
    .selectAll("text")
    .data(dataMapUnitBar)
    .join("text")
    .attr("x", (d, i) => {
      if (i == 0) {
        return xProportionBar(dataBar[i] / 2) - 2;
      } else {
        return (
          xProportionBar((dataBar[i] - dataBar[i - 1]) / 2 + dataBar[i - 1]) - 2
        );
      }
    })
    .attr("y", yProportionBar(0) + yProportionBar.bandwidth() / 2 + 5)
    .text((d, i) => i + 1)
    .style("font-weight", "bold");

  svg
    .append("text")
    .attr(
      "transform",
      "translate(" +
        (graphWidth - 125 + marginStackedBar.left) / 2 +
        " ," +
        (proportionBarHeight - 5) +
        ")"
    )
    .style("text-anchor", "middle")
    .text("Proportion (%)");

  svg.append("g").call(xAxisProportionBar);

  return svg.node();
}
);
  main.variable(observer("chartBarLegend1")).define("chartBarLegend1", ["d3","DOM","margin","dataMapUnitBar","appendLegendText"], function(d3,DOM,margin,dataMapUnitBar,appendLegendText)
{
  const svg = d3
    .select(DOM.svg(200, margin.top + 10 + dataMapUnitBar.length * 20))
    .style("overflow", "visible")
    .style("font", "12px sans-serif");

  const j = svg
    .append("g")
    .selectAll("g")
    .data(dataMapUnitBar)
    .join("g")
    .attr("transform", (d, i) => `translate(${0},${i * 20 + margin.top + 10})`);
  j.append("text")
    .attr("x", 0)
    .attr("y", 9.5)
    .attr("dy", "0.35em")
    .text(
      (d, i) => `${i + 1}: ${d.fullSmapName}  (${d.smapHubSiblingProportion}%)`
    );

  appendLegendText(svg, "Sibling", 0, margin.top);

  return svg.node();
}
);
  main.variable(observer("chartBarLegend2")).define("chartBarLegend2", ["d3","DOM","margin","usedOrders","colorPie","crossHatch","appendLegendText"], function(d3,DOM,margin,usedOrders,colorPie,crossHatch,appendLegendText)
{
  const svg = d3
    .select(DOM.svg(200, margin.top + 10 + usedOrders.length * 20))
    .style("overflow", "visible")
    .style("font", "12px sans-serif");

  const h = svg
    .append("g")
    .selectAll("g")
    .data(usedOrders)
    .join("g")
    .attr("transform", (d, i) => `translate(${0},${i * 20 + margin.top + 10})`);
  h.append("rect")
    .attr("width", 19)
    .attr("height", 19)
    .attr("fill", d => {
      if (d.order != "Bare rock") {
        return colorPie(d.order);
      } else {
        svg.call(crossHatch);
        return crossHatch.url();
      }
    });
  h.append("text")
    .attr("x", 24)
    .attr("y", 9.5)
    .attr("dy", "0.35em")
    .text(d => d.order);

  appendLegendText(svg, "Soil Order", 0, margin.top);

  return svg.node();
}
);
  main.variable(observer()).define(["md"], function(md){return(
md `## Appendix (Proportion Charts)`
)});
  main.variable(observer("soilOrderColours")).define("soilOrderColours", function(){return(
[
  {order: "Anthropic", colour: "#7C7C7D"},
  {order: "Allophanic", colour: "#FF9999"},
  {order: "Brown", colour: "#927757"},
  {order: "Gley", colour: "#7D8FF4"},
  {order: "Granular", colour: "#BAD78F"},
  {order: "Melanic", colour: "#888C3C"},
  {order: "Organic", colour: "#822405"},
  {order: "Pallic", colour: "#56D5A9"},
  {order: "Podzol", colour: "#D1AAFF"},
  {order: "Pumice", colour: "#CDBDCC"},
  {order: "Raw", colour: "#D5D59A"},
  {order: "Recent", colour: "#F1F96D"}, 
  {order: "Semiarid", colour: "#FFA100"},
  {order: "Ultic", colour: "#DB7A6D"}
]
)});
  main.variable(observer("usedOrders")).define("usedOrders", ["soilOrderColours","dataMapUnitBar"], function(soilOrderColours,dataMapUnitBar)
{
  let inSoilOrders = [];
  soilOrderColours.forEach(function(item) {
    let index = dataMapUnitBar.findIndex(x => x.nzscOrderTxt == item.order);
    if (
      index != -1 &&
      inSoilOrders.findIndex(x => x.order == item.order) === -1
    ) {
      inSoilOrders.push(item);
    }
  });

  dataMapUnitBar.forEach(function(element) {
    let bareRockFound = false;
    if (!bareRockFound && element.fullSmapName == "Bare rock") {
      bareRockFound = true;
      inSoilOrders.push({ order: "Bare rock", colour: "Bare rock" });
    }
  });
  return inSoilOrders;
}
);
  main.variable(observer("colorPie")).define("colorPie", ["d3","soilOrderColours"], function(d3,soilOrderColours){return(
d3.scaleOrdinal()
    //.domain(data.map(d => d.name))
    //.range(d3.quantize(t => d3.interpolateSinebow(t * 0.8 + 0.1), data.length).reverse())
    .unknown("#ccc")
    .domain(soilOrderColours.map(d => d.order))
    .range(soilOrderColours.map(d => d.colour))
)});
  main.variable(observer("proportionBarHeight")).define("proportionBarHeight", function(){return(
175
)});
  main.variable(observer("xProportionBar")).define("xProportionBar", ["d3","marginStackedBar","width","margin"], function(d3,marginStackedBar,width,margin){return(
d3
  .scaleLinear()
  .domain([0, 100])
  .range([marginStackedBar.left, width - margin.right])
)});
  main.variable(observer("yProportionBar")).define("yProportionBar", ["d3","marginStackedBar","proportionBarHeight"], function(d3,marginStackedBar,proportionBarHeight){return(
d3
  .scaleBand()
  .domain([0])
  .range([marginStackedBar.top, proportionBarHeight - marginStackedBar.bottom])
  .padding(0.1)
)});
  main.variable(observer("xAxisProportionBar")).define("xAxisProportionBar", ["proportionBarHeight","margin","d3","xProportionBar","width"], function(proportionBarHeight,margin,d3,xProportionBar,width){return(
g => g
    .attr("transform", `translate(0,${proportionBarHeight - margin.bottom})`)
    .call(d3.axisBottom(xProportionBar).ticks(width / 80))
)});
  main.variable(observer()).define(["md"], function(md){return(
md `## Appendix (Stacked Bar Charts)`
)});
  main.variable(observer()).define(["md"], function(md){return(
md `### Appends`
)});
  main.variable(observer("appendLegendText2")).define("appendLegendText2", ["graphWidth","margin"], function(graphWidth,margin){return(
function(object, firstText) {
  object
    .append("text")
    .attr("x", graphWidth)
    .attr("y", margin.top)
    .text(firstText)
    .style("font-weight", "bold");

  object
    .append("text")
    .attr("x", graphWidth)
    .attr("y", margin.top + 160)
    .text("Stone Content")
    .style("font-weight", "bold");

  object
    .append("text")
    .attr("x", graphWidth)
    .attr("y", margin.top + 410)
    .text("Other")
    .style("font-weight", "bold");
}
)});
  main.variable(observer("appendLegend2")).define("appendLegend2", ["siblingTextures","margin","colorTexture","siblingTextureNames"], function(siblingTextures,margin,colorTexture,siblingTextureNames){return(
function(object) {
  const h = object
    .append("g")
    .selectAll("g")
    .data(siblingTextures)
    .join("g")
    .attr("transform", (d, i) => `translate(${0},${i * 20 + margin.top + 10})`);

  h.append("rect")
    .attr("width", 19)
    .attr("height", 19)
    .attr("fill", d => colorTexture(d));

  h.append("text")
    .attr("x", 24)
    .attr("y", 9.5)
    .attr("dy", "0.35em")
    .text(d => siblingTextureNames[d]);

  return object;
}
)});
  main.variable(observer("appendOtherLegend2")).define("appendOtherLegend2", ["standardOtherKeys","margin","crossHatch"], function(standardOtherKeys,margin,crossHatch){return(
function(object, position) {
  const j = object
    .append("g")
    .selectAll("g")
    .data(standardOtherKeys)
    .join("g")
    .attr("transform", (d, i) => {
      return `translate(${0},${i * 42 + margin.top + position})`;
    });

  j.append("rect")
    .attr("width", 38)
    .attr("height", 38)
    .attr("fill", (d, i) => {
      if (d == "Rock") {
        object.call(crossHatch);
        return crossHatch.url();
      } else if (d == "Rooting Barrier") {
        return "white";
      }
    })
    .style("stroke", (d, i) => {
      if (d == "Rooting Barrier") {
        return "purple";
      }
    })
    .style("stroke-alignment", d => {
      if (d == "Rooting Barrier") {
        return "inner";
      }
    })
    .style("stroke-width", d => {
      if (d == "Rooting Barrier") {
        return 3;
      }
    });

  j.append("text")
    .attr("x", 44)
    .attr("y", 18.5)
    .attr("dy", "0.35em")
    .text(d => d);

  return object;
}
)});
  main.variable(observer("appendLegendHeaderText")).define("appendLegendHeaderText", ["graphWidth","margin"], function(graphWidth,margin){return(
function(object, text1, text2, position2) {
  object
    .append("text")
    .attr("x", graphWidth)
    .attr("y", margin.top)
    .text(text1)
    .style("font-weight", "bold");

  object
    .append("text")
    .attr("x", graphWidth)
    .attr("y", margin.top + position2)
    .text(text2)
    .style("font-weight", "bold");
}
)});
  main.variable(observer("appendLegendPermeability")).define("appendLegendPermeability", ["pLegend","pColor","pLegendDrainage"], function(pLegend,pColor,pLegendDrainage){return(
function(object) {
  const h = object
    .append("g")
    .selectAll("g")
    .data(pLegend)
    .join("g")
    .attr("transform", (d, i) => `translate(${0},${i * 20 + 40})`);

  h.append("rect")
    .attr("width", 19)
    .attr("height", 19)
    .attr("fill", (d, i) => pColor(d));

  h.append("text")
    .attr("x", 24)
    .attr("y", 9.5)
    .attr("dy", "0.35em")
    .text(d => pLegendDrainage[d]);

  return object;
}
)});
  main.variable(observer("appendOtherLegend3")).define("appendOtherLegend3", ["standardOtherKeys","margin","crossHatch"], function(standardOtherKeys,margin,crossHatch){return(
function(object, position) {
  const j = object
    .append("g")
    .selectAll("g")
    .data(standardOtherKeys)
    .join("g")
    .attr("transform", (d, i) => {
      return `translate(${0},${i * 42 + margin.top + position})`;
    });

  j.append("rect")
    .attr("width", 38)
    .attr("height", 38)
    .attr("fill", (d, i) => {
      if (d == "Rock") {
        object.call(crossHatch);
        return crossHatch.url();
      } else if (d == "Rooting Barrier") {
        return "white";
      }
    })
    .style("stroke", (d, i) => {
      if (d == "Rooting Barrier") {
        return "#962E2B";
      }
    })
    .style("stroke-alignment", d => {
      if (d == "Rooting Barrier") {
        return "inner";
      }
    })
    .style("stroke-width", d => {
      if (d == "Rooting Barrier") {
        return 3;
      }
    });

  j.append("text")
    .attr("x", 44)
    .attr("y", 18.5)
    .attr("dy", "0.35em")
    .text(d => {
      if (d == "Rooting Barrier") {
        return "Permeability Barrier";
      } else {
        return d;
      }
    });

  return object;
}
)});
  main.variable(observer("appendLegendAW2")).define("appendLegendAW2", ["availableWaterOtherKeys","margin","crossHatch","textures"], function(availableWaterOtherKeys,margin,crossHatch,textures){return(
function(object, position, colour) {
  const j = object
    .append("g")
    .selectAll("g")
    .data(availableWaterOtherKeys)
    .join("g")
    .attr("transform", (d, i) => {
      return `translate(${0},${i * 42 + margin.top + position})`;
    });

  j.append("rect")
    .attr("width", 38)
    .attr("height", 38)
    .attr("fill", (d, i) => {
      if (d == "Rock") {
        object.call(crossHatch);
        return crossHatch.url();
      } else if (d == "Rooting Barrier") {
        return "white";
      } else if (d == "Below Root Zone") {
        let barrierHatch = textures
          .lines()
          .orientation("2/8", "6/8")
          .stroke("#555")
          .size(9)
          .strokeWidth(2)
          .background("white");
        object.call(barrierHatch);
        return barrierHatch.url();
      }
    })
    .style("stroke", (d, i) => {
      if (d == "Rooting Barrier") {
        return colour;
      }
    })
    .style("stroke-alignment", d => {
      if (d == "Rooting Barrier") {
        return "inner";
      }
    })
    .style("stroke-width", d => {
      if (d == "Rooting Barrier") {
        return 3;
      }
    });

  j.append("text")
    .attr("x", 44)
    .attr("y", 18.5)
    .attr("dy", "0.35em")
    .text(d => {
      if (d == "Rooting Barrier") {
        return "Rooting Barrier";
      } else {
        return d;
      }
    });

  return object;
}
)});
  main.variable(observer("appendLegendAW")).define("appendLegendAW", ["awLegend","colorAW"], function(awLegend,colorAW){return(
function(object) {
  const h = object
    .append("g")
    .selectAll("g")
    .data(awLegend)
    .join("g")
    .attr("transform", (d, i) => `translate(${0},${i * 20 + 40})`);

  h.append("rect")
    .attr("width", 19)
    .attr("height", 19)
    .attr("fill", (d, i) => colorAW(4 - i))
    .style("opacity", 0.7);

  h.append("text")
    .attr("x", 24)
    .attr("y", 9.5)
    .attr("dy", "0.35em")
    .text((d, i) => awLegend[i] + "%");

  return object;
}
)});
  main.variable(observer("appendStoneContentLegend2")).define("appendStoneContentLegend2", ["stoneContentKeys","margin","images"], function(stoneContentKeys,margin,images){return(
function(object, position, type) {
  const h = object
    .append("g")
    .selectAll("g")
    .data(stoneContentKeys)
    .join("g")
    .attr(
      "transform",
      (d, i) => `translate(${0},${i * 42 + margin.top + position})`
    );

  // h.append("rect")
  //   .attr("width", 38)
  //   .attr("height", 38)
  //   .attr("fill", (d, i) => {
  //     if (i == 0) {
  //       return "white";
  //     } else {
  //       object.call(stoneContentLegend[i-1]);
  //       return stoneContentLegend[i-1].url();
  //     }
  //   })
  //   .style("stroke", "#ccc");

  h.append("rect")
    .attr("width", 38)
    .attr("height", 38)
    .attr("fill", d => "white")
    .style("stroke", "#ccc");

  h.append("svg:image")
    .attr("xlink:href", (d, i) => {
      if (type == 0) {
        if (i == 1) {
          return images.light;
        } else if (i == 2) {
          return images.medium;
        } else if (i == 3) {
          return images.heavy;
        } else if (i == 4) {
          return images.veryHeavy;
        }
      }
    })
    .attr("preserveAspectRatio", "none")
    .attr('height', 38)
    .attr("width", 38)
    .style("opacity", 0.675);

  h.append("text")
    .attr("x", 44)
    .attr("y", 18.5)
    .attr("dy", "0.35em")
    .text(d => d);

  return object;
}
)});
  main.variable(observer("appendStoneContentLegend")).define("appendStoneContentLegend", ["stoneContentKeys","graphWidth","margin","stoneContentLegend"], function(stoneContentKeys,graphWidth,margin,stoneContentLegend){return(
function(object, position) {
  
  const h = object.append("g")
  .selectAll("g")
  .data(stoneContentKeys)
  .join("g")
  .attr("transform", (d, i) => `translate(${graphWidth},${i * 42 + margin.top + position})`)

  h.append("rect")
    .attr("width", 38)
    .attr("height", 38)
    .attr("fill", (d, i) => {
      if (i == 0) {
        return "white";
      } else {
        object.call(stoneContentLegend[i-1]);
        return stoneContentLegend[i-1].url();
      }
    })
    .style("stroke", "#ccc");

  h.append("text")
    .attr("x", 44)
    .attr("y", 18.5)
    .attr("dy", "0.35em")
    .text(d => d);
  
  return object;
}
)});
  main.variable(observer()).define(["md"], function(md){return(
md `### Lines`
)});
  main.variable(observer("barrierLineWidth")).define("barrierLineWidth", function(){return(
6
)});
  main.variable(observer("appendBarrierLine")).define("appendBarrierLine", ["barrierLineWidth","x","y"], function(barrierLineWidth,x,y){return(
function(graphData, object, barrierType, barrierColor) {
  const line = object
    .append("g")
    .selectAll("g")
    .data(graphData)
    .enter()
    .append("g");

  const line_enter = line
    .selectAll("rect")
    .data(d => d)
    .enter();

  // Top
  line_enter
    .append("line")
    .attr("stroke-width", (d, i) => {
      if (d.data[barrierType] == d.key + 1) {
        return barrierLineWidth;
      } else if (
        d.data.thickType == "R" &&
        d.key == "rock" &&
        d.data[barrierType] == 0
      ) {
        return barrierLineWidth;
      } else {
        return 0;
      }
    })
    .attr("x1", (d, i) => {
      return x(d.data.smapName);
    })
    .attr("y1", d => {
      if (isNaN(y(d[0]) + barrierLineWidth / 2)) {
        return 0;
      } else {
        return y(d[0]) + barrierLineWidth / 2;
      }
    })
    .attr("x2", (d, i) => x(d.data.smapName) + x.bandwidth())
    .attr("y2", d => {
      if (isNaN(y(d[0]) + barrierLineWidth / 2)) {
        return 0;
      } else {
        return y(d[0]) + barrierLineWidth / 2;
      }
    })
    .attr("stroke", d => {
      if (
        (d.data[barrierType] > 0 ||
          (d.data.thickType == "R" && d.key == "rock")) &&
        !isNaN(d[1])
      ) {
        return barrierColor;
      }
    });

  // Bottom
  line_enter
    .append("line")
    .attr("stroke-width", (d, i) => {
      if (d.data[barrierType] == d.key + 1) {
        return barrierLineWidth;
      } else if (
        d.data.thickType == "R" &&
        d.key == "rock" &&
        d.data[barrierType] == 0
      ) {
        return barrierLineWidth;
      } else {
        return 0;
      }
    })
    .attr("x1", (d, i) => {
      return x(d.data.smapName);
    })
    .attr("y1", d => {
      if (isNaN(y(d[1]) - barrierLineWidth / 2)) {
        return 0;
      } else {
        return y(d[1]) - barrierLineWidth / 2;
      }
    })
    .attr("x2", (d, i) => x(d.data.smapName) + x.bandwidth())
    .attr("y2", d => {
      if (isNaN(y(d[1]) - barrierLineWidth / 2)) {
        return 0;
      } else {
        return y(d[1]) - barrierLineWidth / 2;
      }
    })
    .attr("stroke", d => {
      if (
        (d.data[barrierType] > 0 ||
          (d.data.thickType == "R" && d.key == "rock")) &&
        !isNaN(d[1])
      ) {
        return barrierColor;
      }
    });

  // Left
  line_enter
    .append("line")
    .attr("stroke-width", (d, i) => {
      if (d.data[barrierType] == d.key + 1) {
        return barrierLineWidth;
      } else if (
        d.data.thickType == "R" &&
        d.key == "rock" &&
        d.data[barrierType] == 0
      ) {
        return barrierLineWidth;
      } else {
        return 0;
      }
    })
    .attr("x1", (d, i) => x(d.data.smapName) + barrierLineWidth / 2)
    .attr("y1", d => {
      if (typeof y(d[0]) !== 'undefined') {
        return y(d[0]);
      } else {
        return 0;
      }
    })
    .attr("x2", (d, i) => x(d.data.smapName) + barrierLineWidth / 2)
    .attr("y2", d => {
      if (typeof y(d[1]) !== 'undefined') {
        return y(d[1]);
      } else {
        return 0;
      }
    })
    .attr("stroke", d => {
      if (
        (d.data[barrierType] > 0 ||
          (d.data.thickType == "R" && d.key == "rock")) &&
        !isNaN(d[1])
      ) {
        return barrierColor;
      }
    });

  // Right
  line_enter
    .append("line")
    .attr("stroke-width", (d, i) => {
      if (d.data[barrierType] == d.key + 1) {
        return barrierLineWidth;
      } else if (
        d.data.thickType == "R" &&
        d.key == "rock" &&
        d.data[barrierType] == 0
      ) {
        return barrierLineWidth;
      } else {
        return 0;
      }
    })
    .attr(
      "x1",
      (d, i) => x(d.data.smapName) + x.bandwidth() - barrierLineWidth / 2
    )
    .attr("y1", d => {
      if (typeof y(d[0]) !== 'undefined') {
        return y(d[0]);
      } else {
        return 0;
      }
    })
    .attr(
      "x2",
      (d, i) => x(d.data.smapName) + x.bandwidth() - barrierLineWidth / 2
    )
    .attr("y2", d => {
      if (typeof y(d[1]) !== 'undefined') {
        return y(d[1]);
      } else {
        return 0;
      }
    })
    .attr("stroke", d => {
      if (
        (d.data[barrierType] > 0 ||
          (d.data.thickType == "R" && d.key == "rock")) &&
        !isNaN(d[1])
      ) {
        return barrierColor;
      }
    });

  return object;
}
)});
  main.variable(observer("appendFHLines")).define("appendFHLines", ["x","y"], function(x,y){return(
function(enter, dataset) {
  // x line top
  enter.append("line")
    .attr("x1", (d, i) => x(dataset.names[i]) - 5)
    .attr("y1", d => y(d[0]))
    .attr("x2", (d,i) => x(dataset.names[i]) - 20)
    .attr("y2", d => y(d[0]))
    .attr("stroke", d => {
      if (d[0] >= 100 || isNaN(d[1]) || !d[2].includes("ThickMean")) {
        return 'none';
      } else {
        return 'gray';
      }
    });
  // x line bottom
  enter.append("line")
    .attr("x1", (d, i) => x(dataset.names[i]) - 5)
    .attr("y1", d => y(d[1]))
    .attr("x2", (d,i) => x(dataset.names[i]) - 20)
    .attr("y2", d => y(d[1]))
    .attr("stroke", d => {
      if (d[0] >= 100 || isNaN(d[1]) || !d[2].includes("ThickMean")) {
        return 'none';
      } else {
        return 'gray';
      }
    });
  // y line top
  enter.append("line")
    .attr("x1", (d, i) => x(dataset.names[i]) - 12.5)
    .attr("y1", d => y(d[0]))
    .attr("x2", (d,i) => x(dataset.names[i]) - 12.5)
    .attr("y2", d => {
      if (y(d[1]) - y(d[0]) >= 32) {
        return y(d[0]) + (y(d[1]) - y(d[0])) / 2 - 12;
      } else {
        return y(d[1]);
      }
    })
    .attr("stroke", d => {
      if (d[0] >= 100 || isNaN(d[1]) || !d[2].includes("ThickMean")) {
        return 'none';
      } else {
        return 'gray';
      }
    });
  // y line bottom
  enter.append("line")
    .attr("x1", (d, i) => x(dataset.names[i]) - 12.5)
    .attr("y1", d => y(d[1]))
    .attr("x2", (d,i) => x(dataset.names[i]) - 12.5)
    .attr("y2", d => y(d[1]) - (y(d[1]) - y(d[0])) / 2 + 12)
    .attr("stroke", d => {
      if (d[0] >= 100 || isNaN(d[1]) || !d[2].includes("ThickMean") || y(d[1]) - y(d[0]) < 32) {
        return 'none';
      } else {
        return 'gray';
      }
    });
}
)});
  main.variable(observer()).define(["md"], function(md){return(
md `### Textures`
)});
  main.variable(observer("qTexture")).define("qTexture", ["textures"], function(textures){return(
textures.lines()
  .stroke("black")
  .size(10)
  .strokeWidth(1)
)});
  main.variable(observer("crossHatch")).define("crossHatch", ["textures"], function(textures){return(
textures.lines()
  .orientation("2/8", "6/8")
  .stroke("black")
  .size(9)
  .strokeWidth(1)
  .background("dimgray")
)});
  main.variable(observer("stoneContentLegend")).define("stoneContentLegend", ["textures"], function(textures)
{
  const circles = [];
    let thinCircle = textures.circles()
      .lighter()
      .complement();

    let middleCircle = textures.circles()
      .radius(3)
      .fill("transparent")
      .strokeWidth(1)
      .complement();

    let thickCircle = textures.circles()
      .radius(4)
      .size(16)
      .fill("transparent")
      .strokeWidth(1)
      .complement();
  
  circles.push(thinCircle);
  circles.push(middleCircle);
  circles.push(thickCircle);
  
  return circles;
}
);
  main.variable(observer()).define(["md"], function(md){return(
md `### Keys`
)});
  main.variable(observer("functionalHorizonKeys")).define("functionalHorizonKeys", function(){return(
["FH1", "FH2", "FH3", "FH4", "FH5", "FH6"]
)});
  main.variable(observer("siblingTextures")).define("siblingTextures", function(){return(
["L", "A", "Y", "Q", "J", "O"]
)});
  main.variable(observer("siblingTextureNames")).define("siblingTextureNames", function(){return(
{"L": "Loamy", "A": "Sandy", "Y": "Clayey", "Q": "Indurated pan", "J": "Fluid", "O": "Organic"}
)});
  main.variable(observer("pLegend")).define("pLegend", function(){return(
["r", "m", "ms", "s", "xs"]
)});
  main.variable(observer("awLegend")).define("awLegend", function(){return(
[">30", "20-30", "15-20", "10-15", "<10"]
)});
  main.variable(observer("pLegendDrainage")).define("pLegendDrainage", function(){return(
{
  r: "Rapid (R; >72 mm/h)",
  m: "Moderate (M; 18-72 mm/h)",
  ms: "Moderately slow (MS; 4-18 mm/h)",
  s: "Slow (S; 0.1-4 mm/h)",
  xs: "Impermeable (XS)"
}
)});
  main.variable(observer("stoneContentKeys")).define("stoneContentKeys", function(){return(
["0%", "1-5%", "5-35%", "35-70%", "70+%"]
)});
  main.variable(observer("textureKeys")).define("textureKeys", function(){return(
["Indurated pan", "Rock", "Rooting Barrier"]
)});
  main.variable(observer("standardOtherKeys")).define("standardOtherKeys", function(){return(
["Rock", "Rooting Barrier"]
)});
  main.variable(observer("availableWaterOtherKeys")).define("availableWaterOtherKeys", function(){return(
["Rock", "Rooting Barrier", "Below Root Zone"]
)});
  main.variable(observer()).define(["md"], function(md){return(
md `### Data`
)});
  main.variable(observer("dataLocation")).define("dataLocation", function()
{
  // return "https://gist.githubusercontent.com/RenBidge/74c4cde380a6cc8c391ab990f3509827/raw/ba1629454a93db9ab2ec80f111eed55bdfdced4e/TestDataMapUnit.csv";
}
);
  main.variable(observer("dataLocationShape")).define("dataLocationShape", function()
{
  return "https://gist.githubusercontent.com/RenBidge/74c4cde380a6cc8c391ab990f3509827/raw/172b8ea4add865403ab35e722b19142531d3c1aa/TestDataMapUnitShape.csv";
}
);
  main.variable(observer("dataMapUnitBar")).define("dataMapUnitBar", function()
{
  // return d3.csv(dataLocation);
  return [];
}
);
  main.variable(observer("dataMapUnit")).define("dataMapUnit", ["dataMapUnitBar"], function(dataMapUnitBar)
{
  return dataMapUnitBar.filter(element => element.fullSmapName != "Bare rock");
}
);
  main.variable(observer("dataPolygon")).define("dataPolygon", ["d3","dataLocationShape"], function(d3,dataLocationShape)
{
  return d3.csv(dataLocationShape);
  // return [];
}
);
  main.variable(observer("dataTable")).define("dataTable", ["dataMapUnitBar"], function(dataMapUnitBar)
{
  return dataMapUnitBar.map((element, i) => {
    return {
      "No.": i + 1,
      "Smap name": element.fullSmapName,
      "Proportion (%)": element.smapHubSiblingProportion,
      Depth: element.siblingDepthDescription,
      Texture: element.siblingTextureText,
      "Drainage class": element.siblingDrainageDescription,
      PAW: element.wrcPawMm,
      Order: element.nzscOrderTxt
    };
  });
}
);
  main.variable(observer("dataTexture")).define("dataTexture", ["normalizeData","dataMapUnit","moveData","d3","dataNames"], function(normalizeData,dataMapUnit,moveData,d3,dataNames)
{
  let data = normalizeData(dataMapUnit);
  data = moveData(dataMapUnit, data);

  data = data.map(d => {
    for (let i = 0; i < 6; i++) {
      if (!isNaN(d.thickMean[i])) {
        d[i] = d.thickMean[i];
      }
    }
    return d;
  });

  let keys = [0, 1, 2, 3, 4, 5, "rock"];
  data = d3
    .stack()
    .keys(keys)(data)
    .map(d => (d.forEach(v => (v.key = d.key)), d));

  data["names"] = dataNames;
  return data;
}
);
  main.variable(observer("dataPerm")).define("dataPerm", ["normalizeData","dataMapUnit","addPermeability","d3","dataNames"], function(normalizeData,dataMapUnit,addPermeability,d3,dataNames)
{
  let data = normalizeData(dataMapUnit);
  data = addPermeability(dataMapUnit, data);

  data = data.map(d => {
    for (let i = 0; i < 6; i++) {
      if (!isNaN(d.thickMean[i])) {
        d[i] = d.thickMean[i];
      }
    }
    return d;
  });

  let keys = [0, 1, 2, 3, 4, 5, "rock"];

  data = d3
    .stack()
    .keys(keys)(data)
    .map(d => (d.forEach(v => (v.key = d.key)), d));

  data["names"] = dataNames;
  return data;
}
);
  main.variable(observer("dataAW")).define("dataAW", ["normalizeData","dataMapUnit","addAW","d3","dataNames"], function(normalizeData,dataMapUnit,addAW,d3,dataNames)
{
  let data = normalizeData(dataMapUnit);
  data = addAW(dataMapUnit, data);

  data = data.map(d => {
    for (let i = 0; i < 6; i++) {
      if (!isNaN(d.thickMean[i])) {
        d[i] = d.thickMean[i];
      }
    }
    return d;
  });

  let keys = [0, 1, 2, 3, 4, 5, "rock"];

  data = d3
    .stack()
    .keys(keys)(data)
    .map(d => (d.forEach(v => (v.key = d.key)), d));

  data["names"] = dataNames;
  return data;
}
);
  main.variable(observer("dataNames")).define("dataNames", ["dataMapUnit"], function(dataMapUnit)
{
  let names = [];
  dataMapUnit.forEach(element => {
    if (element.fullSmapName != "Bare rock") {
      names.push(element.fullSmapName);
    }
  });
  return names;
}
);
  main.variable(observer("dataBar")).define("dataBar", ["dataMapUnitBar"], function(dataMapUnitBar)
{
  let data = [];
  let total = 0;
  dataMapUnitBar.forEach(element => {
    data.push(parseFloat(element.smapHubSiblingProportion) + total);
    total = total + parseFloat(element.smapHubSiblingProportion);
  });

  return data;
}
);
  main.variable(observer("dataSurveyInfo")).define("dataSurveyInfo", function(){return(
[]
)});
  main.variable(observer()).define(["md"], function(md){return(
md `### Helpers`
)});
  main.variable(observer("addPermeability")).define("addPermeability", function(){return(
function(input, normalizedData) {
  for (let i = 0; i < input.length; i++) {
    normalizedData[i]["permeability"] = [];
    for (let j = 1; j < 7; j++) {
      //fH1PermeabilityCode
      let impermKey = "fh" + j + "PermeabilityCode";
      let impermVal = input[i][impermKey];

      if (
        impermVal != "r" &&
        impermVal != "m" &&
        impermVal != "ms" &&
        impermVal != "s" &&
        impermVal != "xs"
      ) {
        normalizedData[i]["permeability"].push("");
      } else {
        normalizedData[i]["permeability"].push(impermVal);
      }
    }
  }

  return normalizedData;
}
)});
  main.variable(observer("addAW")).define("addAW", function(){return(
function(input, normalizedData) {
  for (let i = 0; i < input.length; i++) {
    normalizedData[i]["availableWater"] = [];
    normalizedData[i]["availableWaterMm"] = [];
    //wrcAwMmFh1
    for (let j = 1; j < 7; j++) {
      let awKey = "wrcAwPercentFh" + j;
      let awVal = input[i][awKey];
      if ((!awVal || awVal == "NULL") && awVal != "0") {
        normalizedData[i]["availableWater"].push("");
      } else {
        normalizedData[i]["availableWater"].push(awVal);
      }
    }
    for (let j = 1; j < 7; j++) {
      let awKey = "wrcAwMmFh" + j;
      let awVal = input[i][awKey];
      if ((!awVal || awVal == "NULL") && awVal != "0") {
        normalizedData[i]["availableWaterMm"].push("");
      } else {
        normalizedData[i]["availableWaterMm"].push(awVal);
      }
    }
  }

  return normalizedData;
}
)});
  main.variable(observer("getSiblingFHTextures")).define("getSiblingFHTextures", function(){return(
function(inputData) {
  let outputData = [];
  for (let i = 0; i < inputData.length; i++) {
    for (let j = 1; j <= 6; j++) {
      if (inputData[i]["siblingFh" + j] == "NULL") {
        outputData.push("NULL");
      } else if (inputData[i]["siblingFh" + j].includes("O")) {
        outputData.push("O");
      } else if (inputData[i]["siblingFh" + j].includes("Y")) {
        outputData.push("Y");
      } else if (inputData[i]["siblingFh" + j].includes("L")) {
        outputData.push("L");
      } else if (inputData[i]["siblingFh" + j].includes("Q")) {
        outputData.push("Q");
      } else if (inputData[i]["siblingFh" + j].includes("J")) {
        outputData.push("J");
      } else if (inputData[i]["siblingFh" + j].includes("A")) {
        outputData.push("A");
      }
    }
  }

  return outputData;
}
)});
  main.variable(observer("normalizeData")).define("normalizeData", ["d3"], function(d3){return(
function(input) {
  const toBeNormalized = input.map(d => {
    return {
      smapName: d.fullSmapName,
      isOverRock: d.isOverRock,
      rootBarrierCode: d.rootBarrierCode,
      thickMean: [
        d.fh1ThickMean,
        d.fh2ThickMean,
        d.fh3ThickMean,
        d.fh4ThickMean,
        d.fh5ThickMean,
        d.fh6ThickMean
      ],
      thickSum: 0,
      thickType: ""
    };
  }).map((d, i) => {
    if (d.isOverRock == 1 && d3.sum(d.thickMean) < 97.5) {
      d["thickSum"] = 100 - d3.sum(d.thickMean);
      d["thickType"] = "R";
    } else if (d3.sum(d.thickMean) > 100) {
      d["thickSum"] = d3.sum(d.thickMean);
    } else if (d.rootBarrierCode != "N") {
      d["thickSum"] = 100;
    } else {
      d["thickSum"] = d3.sum(d.thickMean);
    }
    return d;
  });

  const normalizedData = [];
  toBeNormalized.forEach((element, i) => {
    let obj = {};
    obj["smapName"] = input[i].fullSmapName;
    obj["smapHubSiblingProportion"] = input[i].smapHubSiblingProportion;
    obj["nzscordertxt"] = input[i].nzscOrderTxt;
    obj["rootBarrier"] = input[i].rootBarrierFhNum;
    obj["impermeableFhNum"] = input[i].impermeableFh;
    obj["thickMean"] = [];
    obj["thickType"] = element.thickType;
    for (let j = 0; j < 6; j++) {
      if (element.thickType == "R") {
        obj["rock"] = element.thickSum;
        obj["thickMean"].push(element["thickMean"][j]);
      } else {
        obj["rock"] = 0;
        obj["thickMean"].push(
          (element["thickMean"][j] / element.thickSum) * 100
        );
      }
    }
    normalizedData.push(obj);
  });

  return normalizedData;
}
)});
  main.variable(observer("moveData")).define("moveData", ["siblingTextures"], function(siblingTextures){return(
function(input, normalizedData) {
  for (let i = 0; i < input.length; i++) {
    normalizedData[i]["stoneContent"] = [];
    normalizedData[i]["texture"] = [];
    for (let j = 1; j < 7; j++) {
      // Gets the stone content for the particular sibling FH
      let stoneKey = "fh" + j + "StoneMean";
      let stoneVal = input[i][stoneKey];

      // Retrieves the texture for the current sibling
      let qKey = "siblingFh" + j;
      let qVal = input[i][qKey];

      if (qVal && qVal.includes("Q")) {
        normalizedData[i]["stoneContent"].push(5);
      } else if (stoneVal && stoneVal >= 1 && stoneVal < 5) {
        normalizedData[i]["stoneContent"].push(1);
      } else if (stoneVal && stoneVal >= 5 && stoneVal < 35) {
        normalizedData[i]["stoneContent"].push(2);
      } else if (stoneVal && stoneVal >= 35 && stoneVal < 70) {
        normalizedData[i]["stoneContent"].push(3);
      } else if (stoneVal && stoneVal >= 70) {
        normalizedData[i]["stoneContent"].push(4);
      } else {
        normalizedData[i]["stoneContent"].push(0);
      }

      let found = false;
      for (let k = 0; k < siblingTextures.length; k++) {
        if (qVal && qVal.includes(siblingTextures[k])) {
          normalizedData[i]["texture"].push(siblingTextures[k]);
          found = true;
        }
      }
      if (!found) {
        normalizedData[i]["texture"].push("U");
      }
    }
  }

  return normalizedData;
}
)});
  main.variable(observer("x")).define("x", ["d3","dataNames","chartMargins","width"], function(d3,dataNames,chartMargins,width){return(
d3
  .scaleBand()
  .domain(dataNames)
  .range([chartMargins.left, width - chartMargins.right])
  .padding(0.15)
)});
  main.variable(observer("y")).define("y", ["d3","chartMargins","height"], function(d3,chartMargins,height){return(
d3
  .scaleLinear()
  .domain([0, 100])
  .range([chartMargins.top, height - chartMargins.bottom])
)});
  main.variable(observer("xAxis")).define("xAxis", ["chartMargins","d3","x"], function(chartMargins,d3,x){return(
g => g
    .attr("transform", `translate(0,${chartMargins.top})`)
    .call(d3.axisTop(x).tickSizeOuter(0))
    .call(g => g.selectAll(".domain").remove())
)});
  main.variable(observer("yAxis")).define("yAxis", ["chartMargins","d3","y"], function(chartMargins,d3,y){return(
g =>
  g
    .attr("transform", `translate(${chartMargins.left},0)`)
    .call(d3.axisLeft(y).ticks(null, "s"))
    .call(g => g.selectAll(".domain").remove())
)});
  main.variable(observer("colorTexture")).define("colorTexture", function(){return(
function(id) {
  if (typeof id !== 'undefined') {
    //const colors = ({L: "#F6834F", A: "#FECE7E", Y: "#FBF8B0", Q: "grey", J: "#4288B5", O: "#D1EC9E", "*TESTING* Unknown": "#ddd"});
    const colors = {
      L: /*A lighter yellow (yellow is too bright)*/ "#FBF8B0",
      A: "#D2B48C",
      Y: "#87CEFA",
      Q: "#808080",
      J: "#4169E1",
      O: "#228B22",
      "*TESTING* Unknown": "#ddd",
      U: "#ddd"
    };
    return colors[id];
  } else {
    return "#ddd";
  }
}
)});
  main.variable(observer("pColor")).define("pColor", ["d3","selectedColorP"], function(d3,selectedColorP){return(
d3
  .scaleOrdinal()
  .unknown("#ccc")
  .domain(["r", "m", "ms", "s"])
  .range(
    d3
      .quantize(t => {
        if (selectedColorP == 0) {
          return d3.interpolateBlues(t * 0.8 + 0.1);
        } else if (selectedColorP == 1) {
          return d3.interpolatePurples(t * 0.8 + 0.1);
        } else if (selectedColorP == 2) {
          return d3.interpolateGreens(t * 0.8 + 0.1);
        } else if (selectedColorP == 3) {
          return d3.interpolateGreys(t * 0.8 + 0.1);
        } else if (selectedColorP == 4) {
          return d3.interpolateReds(t * 0.8 + 0.1);
        } else if (selectedColorP == 5) {
          return d3.interpolateRainbow(t * 0.8 + 0.1);
        } else if (selectedColorP == 6) {
          return d3.interpolateSinebow(t * 0.8 + 0.1);
        } else if (selectedColorP == 7) {
          return d3.interpolateWarm(t * 0.8 + 0.1);
        } else if (selectedColorP == 8) {
          return d3.interpolateCool(t * 0.8 + 0.1);
        }
      }, 4)
      .reverse()
  )
)});
  main.variable(observer("colorAW")).define("colorAW", ["d3"], function(d3){return(
d3
  .scaleOrdinal()
  .unknown("#ccc")
  .domain([0, 1, 2, 3, 4])
  .range(d3.quantize(t => d3.interpolateSpectral(t * 0.8 + 0.1), 5))
)});
  main.variable(observer("height")).define("height", function(){return(
700
)});
  main.variable(observer("graphWidth")).define("graphWidth", function(){return(
700
)});
  main.variable(observer("margin")).define("margin", function(){return(
{ top: 30, right: 10, bottom: 40, left: 45 }
)});
  main.variable(observer("chartMargins")).define("chartMargins", function(){return(
{ top: 100, right: 10, bottom: 40, left: 45 }
)});
  main.variable(observer("marginStackedBar")).define("marginStackedBar", function(){return(
{ top: 0, right: 10, bottom: 40, left: 5 }
)});
  main.variable(observer()).define(["md"], function(md){return(
md `### Includes`
)});
  const child1 = runtime.module(define1);
  main.import("select", child1);
  main.variable(observer("d3")).define("d3", ["require"], function(require){return(
require("d3@5")
)});
  main.variable(observer("textures")).define("textures", ["require"], function(require){return(
require("textures")
)});
  main.variable(observer("L")).define("L", ["require"], function(require){return(
require('leaflet@1.6.0')
)});
  main.variable(observer()).define(["html","resolve"], function(html,resolve){return(
html`<link href='${resolve(
  'leaflet@1.6.0/dist/leaflet.css'
)}' rel='stylesheet' />`
)});
  main.variable(observer("omnivore")).define("omnivore", ["require"], function(require){return(
require('https://bundle.run/leaflet-omnivore@0.3.4')
)});
  main.variable(observer()).define(["md"], function(md){return(
md`### Deprecated`
)});
  main.variable(observer("viewof dataLocationOld")).define("viewof dataLocationOld", ["select"], function(select){return(
select({
  title: "Data",
  description: "Please pick a dataset",
  options: [
    {
      value:
        'https://gist.githubusercontent.com/RenBidge/74c4cde380a6cc8c391ab990f3509827/raw/367df9c95d39a203d985961b3376da27e2632cf4/ObservableHQTestDataQEdited.csv',
      label: 'T2'
    },
    {
      value:
        'https://gist.githubusercontent.com/RenBidge/74c4cde380a6cc8c391ab990f3509827/raw/d63d0f15bf7149679a9cd4e0fa1253be0fd38985/ObservableHQTestDataReal2.csv',
      label: 'R2'
    },
    {
      value:
        'https://gist.githubusercontent.com/RenBidge/74c4cde380a6cc8c391ab990f3509827/raw/d63d0f15bf7149679a9cd4e0fa1253be0fd38985/ObservableHQTestData.csv',
      label: 'T1'
    },
    /*{ value: 'https://gist.githubusercontent.com/RenBidge/74c4cde380a6cc8c391ab990f3509827/raw/d63d0f15bf7149679a9cd4e0fa1253be0fd38985/ObservableHQTestDataRootingBarrier.csv', label: 'Rooting barrier' },
    { value: 'https://gist.githubusercontent.com/RenBidge/74c4cde380a6cc8c391ab990f3509827/raw/d63d0f15bf7149679a9cd4e0fa1253be0fd38985/ObservableHQTestDataQ.csv', label: 'T2' },*/
    {
      value:
        'https://gist.githubusercontent.com/RenBidge/74c4cde380a6cc8c391ab990f3509827/raw/d63d0f15bf7149679a9cd4e0fa1253be0fd38985/ObservableHQTestDataReal1.csv',
      label: 'R1'
    },
    {
      value:
        'https://gist.githubusercontent.com/RenBidge/74c4cde380a6cc8c391ab990f3509827/raw/e02a6ba2d75fa585ef3c58da0cf6fa1ee28ca0dd/ObservableHQTestData1.csv',
      label: 'T3'
    }
  ]
})
)});
  main.variable(observer("dataLocationOld")).define("dataLocationOld", ["Generators", "viewof dataLocationOld"], (G, _) => G.input(_));
  main.variable(observer("circlesTexture")).define("circlesTexture", ["textures","colorTexture"], function(textures,colorTexture){return(
function(stoneContent, texture) {
  let noCircle = textures
    .circles()
    .background(colorTexture(texture))
    .fill(colorTexture(texture))
    .stroke(colorTexture(texture));

  let thinCircle = textures
    .circles()
    .lighter()
    .background(colorTexture(texture))
    .complement();

  let middleCircle = textures
    .circles()
    .radius(3)
    .fill("transparent")
    .strokeWidth(1)
    .background(colorTexture(texture))
    .complement();

  let thickCircle = textures
    .circles()
    .radius(4)
    .size(16)
    .fill("transparent")
    .strokeWidth(1)
    .background(colorTexture(texture))
    .complement();

  if (stoneContent == 0 || stoneContent == 4) {
    return noCircle;
  } else if (stoneContent == 1) {
    return thinCircle;
  } else if (stoneContent == 2) {
    return middleCircle;
  } else if (stoneContent == 3) {
    return thickCircle;
  }
}
)});
  main.variable(observer("appendLegendAWDeprecated")).define("appendLegendAWDeprecated", ["graphWidth"], function(graphWidth){return(
function(object) {
  const linearGradient = object
    .append("linearGradient")
    .attr("id", "linear-gradient");

  //Vertical gradient
  linearGradient
    .attr("x1", "0%")
    .attr("y1", "0%")
    .attr("x2", "0%")
    .attr("y2", "100%");

  //Set the color for the start (0%)
  linearGradient
    .append("stop")
    .attr("offset", "0%")
    .attr("stop-color", "#1982c4");

  //Set the color for the end (100%)
  linearGradient
    .append("stop")
    .attr("offset", "100%")
    .attr("stop-color", "#ea3546");

  //Draw the rectangle and fill with gradient
  const rect = object
    .append("rect")
    .attr("x", graphWidth)
    .attr("y", 40)
    .attr("width", 20)
    .attr("height", 100)
    .style("fill", "url(#linear-gradient)");

  const scaleText100 = object
    .append("text")
    .attr("x", graphWidth + 23)
    .attr("y", 45)
    .attr("dy", "0.35em")
    .text(d => "65%");

  const scaleText0 = object
    .append("text")
    .attr("x", graphWidth + 23)
    .attr("y", 135)
    .attr("dy", "0.35em")
    .text(d => "0%");

  return object;
}
)});
  return main;
}
